<app-page-header
  [pageTitle]="'Stock de Semen'"
  [showCreateButton]="true"
  [textButton]="'Recibir pajuelas'"
  (onCreateClick)="openRecepcion()"
/>

<app-filters-container
  [hasData]="stock.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  <app-filter-select
    label="Cliente"
    [options]="clientesOptions"
    [value]="clienteId"
    (valueChange)="onClienteChange($event)"
  />
</app-filters-container>

<app-data-table
  [columns]="columns"
  [data]="stock"
  [loading]="loading"
  [footer]="totales"
  emptySubtitle="Las pajuelas que traen los clientes se cargan con «Recibir pajuelas»"
  (rowClick)="openDetalle($event.item)"
>
  <ng-template appTableCell="cliente" let-item>
    {{ item.cliente?.persona?.nombre_generico || '-' }}
  </ng-template>

  <ng-template appTableCell="toro" let-item>
    <span class="font-medium text-gray-800 dark:text-white">{{ item.toro?.nombre || '-' }}</span>
    @if (item.toro?.hbp) {
      <br><span class="text-xs text-gray-500 dark:text-gray-400">HBP: {{ item.toro.hbp }}</span>
    }
  </ng-template>

  <ng-template appTableCell="partidas" let-item>
    <span class="text-sm text-gray-600 dark:text-gray-400">{{ partidasTexto(item) }}</span>
  </ng-template>

  <ng-template appTableCell="quedan" let-item>
    <span [class]="item.quedan > 0 ? 'font-semibold text-gray-800 dark:text-white' : 'font-semibold text-error-600 dark:text-error-400'">
      {{ item.quedan }}
    </span>
  </ng-template>

  <ng-template appTableCell="acciones" let-item>
    <button (click)="$event.stopPropagation(); openDetalle(item)" [matTooltip]="'Ver partidas, recepciones y salidas'">
      <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
    </button>
  </ng-template>
</app-data-table>
